import { render } from "./CalculAccordion.vue?vue&type=template&id=f24df2be"
import script from "./CalculAccordion.vue?vue&type=script&lang=js"
export * from "./CalculAccordion.vue?vue&type=script&lang=js"

import "./CalculAccordion.vue?vue&type=style&index=0&id=f24df2be&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__